'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('./constants');

var Style = (function (_Component) {
  _inherits(Style, _Component);

  function Style() {
    _classCallCheck(this, Style);

    _Component.apply(this, arguments);
  }

  Style.prototype.render = function render() {
    var gutter = this.props.gutter / 2;
    var style = '\n      .' + _constants.ROW + ':after, .' + _constants.COL + ':after{content:\'\';display:block;height:0;visibility:hidden;clear:both;}\n      .' + _constants.ROW + '{margin-left:auto;margin-right:auto;width:100%;}\n      .' + _constants.COL + '{box-sizing:border-box;-ms-box-sizing:border-box;-moz-box-sizing:border-box;width:100%;max-width:100%;float:left;min-height:1px;}\n      .' + _constants.COL + '{padding-left:' + gutter + 'px;padding-right:' + gutter + 'px;}\n      .' + _constants.COL + ' .' + _constants.ROW + '{margin-left:-' + gutter + 'px;margin-right:-' + gutter + 'px;width:auto;}\n    ';
    return _react2['default'].createElement('style', { dangerouslySetInnerHTML: { __html: style } });
  };

  _createClass(Style, null, [{
    key: 'propTypes',
    value: {
      gutter: _react.PropTypes.number
    },
    enumerable: true
  }]);

  return Style;
})(_react.Component);

exports['default'] = Style;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-cellblock/lib/util/Style.js
// module id = 761
// module chunks = 0